import { Outlet } from 'react-router-dom';
import { AppShell } from './AppShell';
import { ErrorBoundary } from '@/components/error';

/**
 * The shell an ordinary institution user sees.
 *
 * Split out so the platform console can be a sibling layout rather than a
 * variant of this one. The error boundary sits inside the shell so a page crash
 * leaves the navigation standing and the user can go somewhere else, instead of
 * replacing the whole application with an error card.
 */
export function InstitutionLayout() {
  return (
    <AppShell>
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </AppShell>
  );
}
